import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserAlt, FaLock } from "react-icons/fa";

const AdminLogin = () => {
    const [formData, setFormData] = useState({
        mobile: '',
        pass: '',
    });

    const [responseMsg, setResponseMsg] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = (e) => {
        e.preventDefault();
        setResponseMsg('');

        if (formData.mobile === '12345678' && formData.pass === '123') {
            localStorage.setItem('isLoggedIn', 'true');
            setResponseMsg('Login Successful');
            setTimeout(() => {
                navigate('/dashboard');
                navigate('/');
                window.location.reload();
            }, 800);
        } else {
            setResponseMsg('Invalid number or password');
            setTimeout(() => setResponseMsg(''), 2000);
        }
    };

    return (
        <section 
            className="min-vh-100 d-flex justify-content-center align-items-center"
            style={{
                background: "linear-gradient(135deg, #4B79A1, #283E51)",
                padding: "20px"
            }}
        >
            <div 
                className="p-4 p-md-5 rounded-4 shadow-lg text-white"
                style={{
                    width: "100%",
                    maxWidth: "420px",
                    background: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255,255,255,0.25)"
                }}
            >
                <div className="text-center mb-4">
                    <h2 className="fw-bold">Admin Login</h2>
                    <p className="text-light" style={{ opacity: 0.8 }}>
                        Secure access for administrators
                    </p>
                </div>

                {/* Response Message */}
                {responseMsg && (
                    <div className="alert alert-info text-center py-2">
                        {responseMsg}
                    </div>
                )}

                <form onSubmit={handleLogin}>
                    
                    {/* Mobile Field */}
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Mobile Number</label>
                        <div className="input-group">
                            <span className="input-group-text bg-white border-0">
                                <FaUserAlt />
                            </span>
                            <input
                                type="tel"
                                className="form-control form-control-lg border-0"
                                name="mobile"
                                maxLength="10"
                                value={formData.mobile}
                                onChange={handleChange}
                                placeholder="Enter mobile number"
                            />
                        </div>
                    </div>

                    {/* Password Field */}
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Password</label>
                        <div className="input-group">
                            <span className="input-group-text bg-white border-0">
                                <FaLock />
                            </span>
                            <input
                                type="password"
                                className="form-control form-control-lg border-0"
                                name="pass"
                                value={formData.pass}
                                onChange={handleChange}
                                placeholder="Enter password"
                            />
                        </div>
                    </div>

                    {/* Button */}
                    <button 
                        type="submit" 
                        className="btn btn-light btn-lg w-100 mt-4 fw-bold shadow-sm"
                        style={{
                            borderRadius: "50px",
                            letterSpacing: "0.5px"
                        }}
                    >
                        Login Now
                    </button>
                </form>
            </div>
        </section>
    );
};

export default AdminLogin;
